import { Accordion, Col, Container, Row } from "react-bootstrap";
import projectname from "../../../Assets/images/profile-managment/project-name.svg"
import email from "../../../Assets/images/profile-managment/email.png"
import volunteers from "../../../Assets/images/profile-managment/Volunteers.svg"
import DetailItem from "./DataItem.js"
const ProjectDetailsAccordion= ({sampleRequestDetails, type, isCollectSample })=>{
return(
<Accordion.Item eventKey="1">
    <Accordion.Header><b>Project Details</b></Accordion.Header>
    <Accordion.Body>
        {/* Container -> div */}
        <div className="el-property-details-card-content"> 
            <Row>
                <Col md={12} className="mx-fit-content">
                    <div className="flex-sec justify-content">
                        <DetailItem
                            iconSrc={projectname}
                            title="Lab name"
                            detail={ sampleRequestDetails?.lab?.name || '-'}
                        />

                        <DetailItem
                            iconSrc={projectname}
                            title="Is this Request Part of Parent Study?"
                            detail={sampleRequestDetails?.parentstudy?.[0]?.is_parent_study === 'yes' ? "Yes" : "No" || '-'}
                        />
                        {sampleRequestDetails?.parentstudy?.[0]?.is_parent_study === 'yes' && (
                        <>
                            <DetailItem
                            iconSrc={projectname}
                            title="Parent Study Name"
                            detail={sampleRequestDetails?.parentstudy?.[0]?.parent_study_title || '-'}
                            /> 
                        </>
                        )}
                        <DetailItem
                            iconSrc={projectname}
                            title="Project Name"
                            detail={sampleRequestDetails?.request?.project_name || '-'}
                        />
                        <DetailItem
                            iconSrc={email}
                            title="Job Number"
                            detail={sampleRequestDetails?.request?.job_id || '-'}
                        />
                        {/* //wbs element commented */}
                        {/* {(type!== 'requestor' && !isCollectSample) && (
                        <>
                         <DetailItem
                            iconSrc={email}
                            title="WBS Element"
                            detail={sampleRequestDetails?.request?.wbs_element || '-'}
                        />
                        </>
                        )} */}
                        <DetailItem
                            iconSrc={volunteers}
                            title="Number of Donors Needed"
                            detail={sampleRequestDetails?.request?.volunteers || '-'}
                        />
                        <DetailItem
                            iconSrc={volunteers}
                            title="Purchase Order"
                            detail={sampleRequestDetails?.request?.purchase_order || '-'}
                        />

                         {sampleRequestDetails?.parentstudy?.[0]?.is_parent_study === 'yes' && (
                        <>
                            <DetailItem
                            iconSrc={projectname}
                            title="Exclude all donors that have already participated in this Parent Study?"
                            detail={sampleRequestDetails?.parentstudy?.[0]?.is_pstudy_donor_exclude === 'yes' ? "Yes" : "No"  || '-'}
                            />
                        </>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    </Accordion.Body>
</Accordion.Item>
 
);
}

export default ProjectDetailsAccordion